import styled from "styled-components"

import { formatPhoneNumber } from "utils/utils"
import { SHIPPING_ACTION_ARR } from "utils/constants"

import SelectBox from "components/presenters/common/form/SelectBox"
import Textarea from "components/presenters/common/form/Textarea"
import SVGIcon from "components/presenters/common/SVGIcon"

export default function CurrShipping({
  address1,
  address2,
  recipient,
  phone,
  shippingDetail,
  shippingAction,
  onChangeShippingDetail,
  onChangeShippingDetailByEtc,
  openShippingChangeWindow,
}) {
  const shippingOptions = [
    { label: "부재시 문앞에 놓아주세요", value: "frontDoor" },
    { label: "배송전에 미리 연락주세요", value: "preCall" },
    { label: "부재시 경비실에 맡겨 주세요", value: "securityOffice" },
    { label: "부재시 전화주시거나 문자 남겨 주세요", value: "textMsgCall" },
    { label: "직접 입력", value: "etc" },
  ]

  return (
    <Block>
      <Header>
        <HeaderLeft>배송지</HeaderLeft>
        <HeaderRight onClick={openShippingChangeWindow}>변경</HeaderRight>
      </Header>
      <ShippingBody>
        <RoadAddressBlock>
          <GeoPinBlock>
            <SVGIcon name="geoPin" />
          </GeoPinBlock>
          <RoadAddress>{address1}</RoadAddress>
        </RoadAddressBlock>
        <DetailAddressBlock>
          <DetailAddress>{address2}</DetailAddress>
          <DetailAddress>{`${recipient} ${formatPhoneNumber(phone)}`}</DetailAddress>
        </DetailAddressBlock>
      </ShippingBody>
      <ShippingActionBlock>
        <SelectBox
          isSearchable={false}
          options={shippingOptions}
          onChange={onChangeShippingDetail}
          {...(shippingDetail && { defaultValue: { label: shippingDetail } })}
          placeholder="배송시 요청사항을 선택해주세요"
          size={3}
        />
        {!SHIPPING_ACTION_ARR.includes(shippingDetail) && (
          <ShippingEtcDetail
            defaultValue={shippingAction}
            onChange={onChangeShippingDetailByEtc}
            placeholder={"배송시 요청사항을 적어주세요"}
          />
        )}
      </ShippingActionBlock>
      <ShippingNotice>* 주문 후에는 배송지 변경이 불가합니다.</ShippingNotice>
    </Block>
  )
}

const Block = styled.div`
  margin-bottom: calc(100vw * (14 / 375));
`

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: calc(100vw * (29 / 375));
  padding-top: calc(100vw * (19 / 375));
`

const HeaderLeft = styled.div`
  font-weight: 700;
  font-size: calc(100vw * (18 / 375));
  line-height: calc(100vw * (16 / 375));
  color: #121212;
`

const HeaderRight = styled.div`
  font-weight: 700;
  font-size: calc(100vw * (16 / 375));
  line-height: calc(100vw * (16 / 375));
  color: #ff9b57;
`

const ShippingBody = styled.div`
  margin-bottom: calc(100vw * (20 / 375));
`

const RoadAddressBlock = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: calc(100vw * (4 / 375));
`

const GeoPinBlock = styled.div`
  width: calc(100vw * (14 / 375));
  height: calc(100vw * (17 / 375));
  margin-right: calc(100vw * (7 / 375));

  svg {
    color: #989898;
  }
`

const RoadAddress = styled.div`
  font-weight: 700;
  font-size: calc(100vw * (14 / 375));
  line-height: calc(100vw * (16 / 375));
  color: #121212;
`

const DetailAddressBlock = styled.div`
  padding-left: calc(100vw * (21 / 375));
`

const DetailAddress = styled.span`
  display: block;
  font-weight: 400;
  font-size: calc(100vw * (14 / 375));
  line-height: calc(100vw * (22 / 375));
  color: #4e4e4e;
`

const ShippingActionBlock = styled.div``

const ShippingEtcDetail = styled(Textarea)`
  padding: calc(100vw * (13 / 375));
  background: #f7f7f7;
  border: none;
  border-radius: calc(100vw * (5 / 375));
  height: calc(100vw * (82 / 375));
  width: 100%;
  margin-top: calc(100vw * (15 / 375));
  font-size: calc(100vw * (14 / 375));
  font-weight: 400;
  line-height: calc(100vw * (16.8 / 375));
  &:focus {
    border: none;
  }
  &::placeholder {
    color: #c6c6c6;
  }
`

const ShippingNotice = styled.span`
  display: block;
  font-weight: 500;
  font-size: calc(100vw * (12 / 375));
  line-height: calc(100vw * (18 / 375));
  color: #7f7f7f;
  margin-top: calc(100vw * (13 / 375));
`
